import {
  TargetSelector,
  getColorSelector,
  makeBorderStyleSelector,
  makeBoxShadowStyleSelector,
  makePaddingStyleSelector
} from "@client/selectors";
import { createSelector } from "reselect";

export const makeDescriptionStyleSelector = () => {
  const paddingSelector = makePaddingStyleSelector(TargetSelector.Entity, "post");

  return createSelector(
    [paddingSelector],
    (padding): React.CSSProperties => ({
      ...padding,
      display: "flex",
      flexDirection: "column"
    })
  );
};

export const makeStyleSelector = () => {
  const backgroundColorSelector = getColorSelector(TargetSelector.Entity, "backgroundColor", "post");

  const borderStyleSelector = makeBorderStyleSelector(TargetSelector.Entity, "post");
  const boxShadowStyleSelector = makeBoxShadowStyleSelector(TargetSelector.Entity, "post");

  return createSelector(
    [borderStyleSelector, boxShadowStyleSelector, backgroundColorSelector],
    (borderStyle, boxShadowStyle, backgroundColor): React.CSSProperties => ({
      ...borderStyle,
      ...boxShadowStyle,
      backgroundColor
    })
  );
};
